import { Application } from '@hotwired/stimulus'

const application = Application.start()

// Configure Stimulus development experience
application.debug = import.meta.env.DEV
window.Stimulus = application

// Auto-register all controllers
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })

Object.entries(controllers).forEach(([path, module]) => {
  const name = path.replace('./', '').replace('_controller.js', '').replace(/\//g, '--').replace(/_/g, '-')

  application.register(name, module.default)
})

export { application }
